import palette from 'lib/styles/palette';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { useNavigate, Link } from 'react-router-dom';
import logoSKShieldusWhite from 'assets/logo-sk-shieldus-white.png';
import logoADTWhite from 'assets/logo-adt-white.png';
import useHeader from 'hooks/common/useHeader';
import webUserGuide from 'assets/web-user-guide.pdf';
import webAdminGuide from 'assets/web-admin-guide.pptx';
import AskModal from './AskModal';

const Header = ({ service }) => {
  const navigate = useNavigate();
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [isConfirmModal, setConfirmModal] = useState(false);
  const { name, data, logout } = useHeader();

  return (
    <>
      {isConfirmModal && (
        <AskModal
          action="확인"
          actionFc={logout}
          message="정말 로그아웃 하시겠습니까?"
          closeModal={() => setConfirmModal(false)}
        />
      )}
      <HeaderBlock>
        <div className="left">
          <img
            className="logo-sk"
            src={logoSKShieldusWhite}
            alt="logo"
            onClick={() => {
              if (service) {
                navigate('/service');
              } else {
                navigate('/admin');
              }
            }}
          />
        </div>
        <div>
          <img
            className="logo"
            src={logoADTWhite}
            alt="logo"
            onClick={() => {
              if (service) {
                navigate('/service');
              } else {
                navigate('/admin');
              }
            }}
          />
        </div>
        <div className="right">
          {!service && (
            <>
              {data?.data.notiCheck && <div className="ret-dot" />}
              <Link className="right-item" to="/admin/notification">
                알림
              </Link>
            </>
          )}
          <div
            className="right-item"
            onClick={() => setShowDownloadModal(prev => !prev)}
          >
            <div>메뉴얼</div>
            {showDownloadModal && (
              <a
                href={service ? webUserGuide : webAdminGuide}
                download={
                  service
                    ? '[스마트 냉난방] Web 사용자 메뉴얼'
                    : '[스마트 냉난방] Web 관리자 메뉴얼'
                }
              >
                <SubModalBlock>다운로드</SubModalBlock>
              </a>
            )}
          </div>
          {service && (
            <div
              className="right-item"
              onClick={() => navigate('/service/users')}
            >
              권한 관리
            </div>
          )}
          <div className="right-user-wrapper">
            <div>{name}</div>
            <div
              className="right-user-wrapper-button"
              onClick={() => setConfirmModal(true)}
            >
              로그아웃
            </div>
          </div>
        </div>
      </HeaderBlock>
    </>
  );
};

export default Header;

const HeaderBlock = styled.div`
  background: ${palette.theme[3]};
  color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  padding: 15px 30px;

  .logo-sk {
    position: absolute;
    top: 8px;
    left: 30px;
    width: 80px;

    @media (max-width: 720px) {
      position: relative;
      top: 0px;
      left: 0;
      width: 30px;
    }
  }

  img {
    cursor: pointer;
  }

  .logo {
    width: 180px;

    @media (max-width: 720px) {
      width: 80px;
    }
  }

  .right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    right: 30px;

    @media (max-width: 720px) {
      position: relative;
      right: 0px;
      margin-left: 5px;
    }
  }

  .right-item {
    margin-left: 0;
    color: #fff;
    position: relative;
    cursor: pointer;
    margin-right: 20px;

    @media (max-width: 720px) {
      margin-right: 5px;
    }
  }

  .right-item:last-child {
    margin-right: 0;
  }

  .ret-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: red;
    margin-right: 10px;
  }

  @media (max-width: 720px) {
    font-size: 8px;
    justify-content: space-between;
  }

  .right-user-wrapper {
    display: flex;

    .right-user-wrapper-button {
      cursor: pointer;
    }

    div {
      margin-right: 10px;
    }
  }
`;

const SubModalBlock = styled.div`
  width: 70px;
  padding: 0.5rem;
  text-align: center;
  border-radius: 10px;
  background: #000;
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  position: absolute;
  top: 25px;
  right: 0;
  cursor: pointer;
  &:hover {
    background: ${palette.theme[2]};
  }

  ${props =>
    !props.service &&
    props.adminUser &&
    css`
      right: 8px;
    `}
`;
